import { saveRecord } from '@/entities/shared/record/save-record';
import { type KitDocument, kitDocumentSchema } from '../schemas/kit-document';

export async function saveDocument(id: string, data: Partial<KitDocument>): Promise<void> {
  await saveRecord('documents', kitDocumentSchema, id, data);
}
